import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface ITedarikciDetay_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface ITedarikciDetay_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: any;
  GoBack_dummy: any;
  Boss_VVendorDetail: any[];
  Boss_VVendorDetail_dummy: any[];
  Boss_VVendorDetailTotal: any[];
  Boss_VVendorDetailTotal_dummy: any[];
  SetValueOf: any;
  SetValueOf_dummy: any;
}

export class TedarikciDetay_ScreenBase extends React.PureComponent<
  ITedarikciDetay_ScreenProps,
  any
> {
  tedarikcidetay_125953_value_kuikaSelectBoxRef: React.RefObject<any>;
  tedarikcidetay_271925_value_kuikaTableRef: React.RefObject<any>;
  tedarikcidetay_727508_value_kuikaPaginationRef: React.RefObject<any>;
  ml = [
    {
      Id: "10a0db45-eac7-4ffc-8246-041db2ced344",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "2135af47-5b9f-4d20-b308-0fc651dc402a",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 963225, PropertyName: "value", Value: "Tedarikçi Detay" },
        { Id: 98513, PropertyName: "value", Value: "Para Birimi" },
        { Id: 190919, PropertyName: "value", Value: "Net Varlık" },
        { Id: 125953, PropertyName: "placeholder", Value: "Zaman Aralığı" },
        { Id: 535927, PropertyName: "title", Value: "Title" },
        { Id: 436709, PropertyName: "value", Value: "[datafield:gun]" },
        { Id: 292787, PropertyName: "value", Value: "[datafield:ay]" },
        { Id: 806566, PropertyName: "value", Value: "[datafield:yil]" },
        { Id: 184037, PropertyName: "value", Value: "[datafield:belgeno]" },
        { Id: 51600, PropertyName: "value", Value: "[datafield:belgetipi]" },
        { Id: 522841, PropertyName: "value", Value: "[datafield:tutar]" },
        { Id: 557518, PropertyName: "value", Value: "[datafield:aciklama]" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);
    this.tedarikcidetay_125953_value_kuikaSelectBoxRef = React.createRef();
    this.tedarikcidetay_271925_value_kuikaTableRef = React.createRef();
    this.tedarikcidetay_727508_value_kuikaPaginationRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      Boss_VVendorDetail: [],
      Boss_VVendorDetailTotal: [],
      SetValueOf: "",
      dataSource_125953: [
        { key: "1", text: "Bugün" },
        { key: "2", text: "Son 7 Gün" },
        { key: "3", text: "Son 1 Ay" },
        { key: "4", text: "Son 3 Ay" },
        { key: "5", text: "Son  6 Ay" },
        { key: "6", text: "Son 1 Yıl" },
        { key: "7", text: "Tüm Tarihler" },
      ],
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("tedarikcidetay", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.TedarikciDetayPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("tedarikcidetay", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("tedarikcidetay", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.TedarikciDetayPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  TedarikciDetayPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      DateFilter_0: ReactSystemFunctions.convertToTypeByName(7, "number"),
      CustomerCode_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerCode ??
          this.props.screenInputs.customercode,
        "string"
      ),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
      DateFilter_1: ReactSystemFunctions.convertToTypeByName(7, "number"),
      CustomerCode_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerCode ??
          this.props.screenInputs.customercode,
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TedarikciDetay/TedarikciDetayPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Boss_VVendorDetail = result?.data.boss_VVendorDetail;

    stateVars.Boss_VVendorDetailTotal = result?.data.boss_VVendorDetailTotal;
    formVars.tedarikcidetay_319076_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VVendorDetailTotal !== undefined
        ? stateVars.Boss_VVendorDetailTotal?.length > 0
          ? stateVars.Boss_VVendorDetailTotal[0].currencyCode
          : null
        : this.state.Boss_VVendorDetailTotal?.length > 0
        ? this.state.Boss_VVendorDetailTotal[0].currencyCode
        : null
    );
    formVars.tedarikcidetay_413616_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VVendorDetailTotal !== undefined
        ? stateVars.Boss_VVendorDetailTotal?.length > 0
          ? stateVars.Boss_VVendorDetailTotal[0].tutar
          : null
        : this.state.Boss_VVendorDetailTotal?.length > 0
        ? this.state.Boss_VVendorDetailTotal[0].tutar
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.TedarikciDetayPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TedarikciDetayPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.tedarikcidetay_319076_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VVendorDetailTotal !== undefined
        ? stateVars.Boss_VVendorDetailTotal?.length > 0
          ? stateVars.Boss_VVendorDetailTotal[0].currencyCode
          : null
        : this.state.Boss_VVendorDetailTotal?.length > 0
        ? this.state.Boss_VVendorDetailTotal[0].currencyCode
        : null
    );

    formVars.tedarikcidetay_413616_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VVendorDetailTotal !== undefined
        ? stateVars.Boss_VVendorDetailTotal?.length > 0
          ? stateVars.Boss_VVendorDetailTotal[0].tutar
          : null
        : this.state.Boss_VVendorDetailTotal?.length > 0
        ? this.state.Boss_VVendorDetailTotal[0].tutar
        : null
    );

    stateVars.dataSource_271925 =
      stateVars.Boss_VVendorDetail ?? this.state.Boss_VVendorDetail;
    formVars.tedarikcidetay_727508_total = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VVendorDetail !== undefined
        ? stateVars.Boss_VVendorDetail?.length > 0
          ? stateVars.Boss_VVendorDetail[0].totalCount
          : null
        : this.state.Boss_VVendorDetail?.length > 0
        ? this.state.Boss_VVendorDetail[0].totalCount
        : null
    );
    formVars.tedarikcidetay_727508_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VVendorDetail !== undefined
        ? stateVars.Boss_VVendorDetail?.length > 0
          ? stateVars.Boss_VVendorDetail[0].pageCount
          : null
        : this.state.Boss_VVendorDetail?.length > 0
        ? this.state.Boss_VVendorDetail[0].pageCount
        : null
    );

    formVars.tedarikcidetay_727508_total = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VVendorDetail !== undefined
        ? stateVars.Boss_VVendorDetail?.length > 0
          ? stateVars.Boss_VVendorDetail[0].totalCount
          : null
        : this.state.Boss_VVendorDetail?.length > 0
        ? this.state.Boss_VVendorDetail[0].totalCount
        : null
    );
    formVars.tedarikcidetay_727508_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VVendorDetail !== undefined
        ? stateVars.Boss_VVendorDetail?.length > 0
          ? stateVars.Boss_VVendorDetail[0].pageCount
          : null
        : this.state.Boss_VVendorDetail?.length > 0
        ? this.state.Boss_VVendorDetail[0].pageCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  TedarikciDetayComponent_544809_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, null);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TedarikciDetayComponent_125953_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      DateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "tedarikcidetay_125953_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      CustomerCode_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerCode ??
          this.props.screenInputs.customercode,
        "string"
      ),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TedarikciDetay/TedarikciDetayComponent_125953_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Boss_VVendorDetail = result?.data.boss_VVendorDetail;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.TedarikciDetayComponent_125953_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TedarikciDetayComponent_125953_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "tedarikcidetay_727508_value",
        "string"
      ),
      1,
      ReactSystemFunctions.convertToTypeByName("current", "string"),
      false
    );

    stateVars.dataSource_271925 =
      stateVars.Boss_VVendorDetail ?? this.state.Boss_VVendorDetail;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TedarikciDetayComponent_727508_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      DateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "tedarikcidetay_125953_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      CustomerCode_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerCode ??
          this.props.screenInputs.customercode,
        "string"
      ),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "tedarikcidetay_727508_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TedarikciDetay/TedarikciDetayComponent_727508_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Boss_VVendorDetail = result?.data.boss_VVendorDetail;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.TedarikciDetayComponent_727508_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TedarikciDetayComponent_727508_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_271925 =
      stateVars.Boss_VVendorDetail ?? this.state.Boss_VVendorDetail;
    formVars.tedarikcidetay_727508_total = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VVendorDetail !== undefined
        ? stateVars.Boss_VVendorDetail?.length > 0
          ? stateVars.Boss_VVendorDetail[0].totalCount
          : null
        : this.state.Boss_VVendorDetail?.length > 0
        ? this.state.Boss_VVendorDetail[0].totalCount
        : null
    );
    formVars.tedarikcidetay_727508_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VVendorDetail !== undefined
        ? stateVars.Boss_VVendorDetail?.length > 0
          ? stateVars.Boss_VVendorDetail[0].pageCount
          : null
        : this.state.Boss_VVendorDetail?.length > 0
        ? this.state.Boss_VVendorDetail[0].pageCount
        : null
    );

    formVars.tedarikcidetay_727508_total = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VVendorDetail !== undefined
        ? stateVars.Boss_VVendorDetail?.length > 0
          ? stateVars.Boss_VVendorDetail[0].totalCount
          : null
        : this.state.Boss_VVendorDetail?.length > 0
        ? this.state.Boss_VVendorDetail[0].totalCount
        : null
    );
    formVars.tedarikcidetay_727508_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VVendorDetail !== undefined
        ? stateVars.Boss_VVendorDetail?.length > 0
          ? stateVars.Boss_VVendorDetail[0].pageCount
          : null
        : this.state.Boss_VVendorDetail?.length > 0
        ? this.state.Boss_VVendorDetail[0].pageCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.TedarikciDetayPageInit();
    }
  }
}
